import { Component, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from '../../../../node_modules/rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  isHome: boolean;
  sub: Subscription;
  menuOpen = false;
  logo = 'assets/images/logo.png';

  constructor(
    private router: Router
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.sub.unsubscribe();
  }


}
